import { lazy } from "react";

const Login = lazy(() => import("../pages/Login"));
const Home = lazy(() => import("../pages/Home"));
const Profile = lazy(() => import("../pages/Profile"));
const PatientTransport = lazy(() =>
  import("../pages/Transports/PatientTransport")
);

export default {
  Login,
  Home,
  Profile,
  PatientTransport,
};
